"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _DefaultButton = _interopRequireDefault(require("./DefaultButton"));

var _SecondaryButton = _interopRequireDefault(require("./SecondaryButton"));

var _TertiaryButton = _interopRequireDefault(require("./TertiaryButton"));

var _StatusButton = _interopRequireDefault(require("./StatusButton"));

var _Link = _interopRequireDefault(require("../typography/Link/Link"));

var _A = _interopRequireDefault(require("../typography/A/A"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ButtonContainer = function ButtonContainer(_ref) {
  var _ref$buttonStyle = _ref.buttonStyle,
      buttonStyle = _ref$buttonStyle === void 0 ? 'primary' : _ref$buttonStyle,
      props = _objectWithoutProperties(_ref, ["buttonStyle"]);

  switch (buttonStyle) {
    case 'primary':
      return _react.default.createElement(_DefaultButton.default, props);

    case 'secondary':
      return _react.default.createElement(_SecondaryButton.default, props);

    case 'tertiary':
      return _react.default.createElement(_TertiaryButton.default, _extends({
        as: props.to ? _Link.default : _A.default,
        "aria-disabled": props.disabled
      }, props));

    default:
      return _react.default.createElement(_StatusButton.default, _extends({
        buttonStyle: buttonStyle
      }, props));
  }
};

var _default = ButtonContainer;
exports.default = _default;